module.exports = __webpack_public_path__ + "img/wf-contents-example.89c1baf0.svg";